"use strict";
// eslint-disable-next-line spaced-comment
/// <reference types="@types/segment-analytics" />
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportingService = exports.SESSION_STORAGE_KEYS = void 0;
const utils_1 = require("../utils");
window.c2foData = window.c2foData || {};
var SESSION_STORAGE_KEYS;
(function (SESSION_STORAGE_KEYS) {
    SESSION_STORAGE_KEYS["UTM_SOURCE"] = "utm_source";
    SESSION_STORAGE_KEYS["UTM_MEDIUM"] = "utm_medium";
    SESSION_STORAGE_KEYS["UTM_CAMPAIGN"] = "utm_campaign";
    SESSION_STORAGE_KEYS["UTM_CONTENT"] = "utm_content";
    SESSION_STORAGE_KEYS["UTM_TERM"] = "utm_term";
    SESSION_STORAGE_KEYS["AUTH_SERVICE_UUID"] = "auth_service_uuid";
    SESSION_STORAGE_KEYS["USER_SESSION_UUID"] = "user_session_uuid";
})(SESSION_STORAGE_KEYS = exports.SESSION_STORAGE_KEYS || (exports.SESSION_STORAGE_KEYS = {}));
function injectSegmentScript(key) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerText = `
  !function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on"];analytics.factory=function(t){return function(){var e=Array.prototype.slice.call(arguments);e.unshift(t);analytics.push(e);return analytics}};for(var t=0;t<analytics.methods.length;t++){var e=analytics.methods[t];analytics[e]=analytics.factory(e)}analytics.load=function(t,e){var n=document.createElement("script");n.type="text/javascript";n.async=!0;n.src="https://cdn.segment.com/analytics.js/v1/"+t+"/analytics.min.js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(n,a);analytics._loadOptions=e};analytics.SNIPPET_VERSION="4.1.0";
  analytics.load('${key}');
  }}();
  `;
    document.body.appendChild(script);
}
function injectAdobeAnalyticsScript(log, adobeLaunchCode) {
    const script = document.createElement('script');
    script.async = true;
    script.src = adobeLaunchCode;
    script.type = 'text/javascript';
    document.head.appendChild(script);
    // eslint-disable-next-line no-underscore-dangle
    if (window._satellite) {
        log.debug('adobe analytics launch code loaded ', adobeLaunchCode);
    }
}
/**
 * TODO: support impersonated users
 */
class ReportingService {
    constructor(httpService, tokenService, namespace, c2foNodeApiUrl, debug, segmentKey, adobeLaunchCode) {
        this.httpService = httpService;
        this.tokenService = tokenService;
        this.namespace = namespace;
        this.c2foNodeApiUrl = c2foNodeApiUrl;
        // In memory cache for track events
        this.eventCache = [];
        this.log = new utils_1.Logger('reporting', debug);
        if (segmentKey) {
            this.segmentEnabled = true;
            injectSegmentScript(segmentKey);
        }
        else {
            this.segmentEnabled = false;
        }
        if (adobeLaunchCode) {
            this.adobeEnabled = true;
            injectAdobeAnalyticsScript(this.log, adobeLaunchCode);
        }
    }
    getAuthServiceUuidFromStorage() {
        // check token first for authenticated user
        const tokenContent = this.tokenService.getTokenContent();
        if (tokenContent && tokenContent.payload.user.uuid) {
            return tokenContent.payload.user.uuid;
        }
        // for usecases like unsubscribe where we will not have a token
        // its expected user auth uuid is written into session storage, pick it from there
        try {
            const storageUuid = window.sessionStorage.getItem(SESSION_STORAGE_KEYS.AUTH_SERVICE_UUID);
            if (storageUuid) {
                return storageUuid;
            }
        }
        catch (e) {
            /* istanbul ignore next */
            this.log.debug('local storage disabled');
        }
        return null;
    }
    getSessionUuid() {
        // get the session uuid from the token
        const tokenContent = this.tokenService.getTokenContent();
        if (tokenContent && tokenContent.payload.user.sessionUuid) {
            return tokenContent.payload.user.sessionUuid;
        }
        return null;
    }
    getImpersonationSubjectUuid() {
        var _a;
        const tokenContent = this.tokenService.getTokenContent();
        return (_a = tokenContent === null || tokenContent === void 0 ? void 0 : tokenContent.payload.impersonationSubject) === null || _a === void 0 ? void 0 : _a.uuid;
    }
    getUserEmailDomain() {
        const tokenContent = this.tokenService.getTokenContent();
        if (tokenContent && tokenContent.payload.user.emailAddress) {
            return tokenContent.payload.user.emailAddress.replace(/.*@/, '');
        }
        return '';
    }
    getAdobeAnalyticsTrackEvents(event, attributes) {
        var _a, _b;
        let trackEvents = ((_b = (_a = window.c2foData) === null || _a === void 0 ? void 0 : _a.digitalData) === null || _b === void 0 ? void 0 : _b.events) || {};
        if (!event) {
            return trackEvents;
        }
        const newEvent = { event, attributes };
        // remove item from cache if we have more than 10 events stored
        if (this.eventCache && this.eventCache.length >= 10) {
            this.eventCache.splice(0, 1);
        }
        this.eventCache.push(newEvent);
        // convert array to object array with unique keys
        trackEvents = this.eventCache.reduce((acc, item) => {
            return Object.assign(Object.assign({}, acc), { [item.event]: item.attributes });
        }, {});
        // write events from event cache into session storage if adobe launch code needs to read
        try {
            window.sessionStorage.setItem('track-events', JSON.stringify(trackEvents));
        }
        catch (e) {
            /* istanbul ignore next */
            this.log.debug('local storage disabled by user');
        }
        return trackEvents;
    }
    setAdobeAnalyticsData(hash, event, attributes) {
        var _a, _b;
        const path = window.location.pathname.split('/');
        const site = 'connect';
        const section = path[1] || this.namespace;
        const subSection = path[2] || 'home';
        // const domain = this.getUserEmailDomain();
        // const userType = domain.toLowerCase() === 'c2fo.com' ? 'internal' : 'client';
        let pageTitle = `${site}${window.location.pathname.replace(/\//g, '|')}${hash ? `|${hash}` : ''}`;
        // when there is no subSection then we are at homepage, AA requirement to set home in the pageTitle
        if (subSection === 'home') {
            pageTitle = `${pageTitle}|${subSection}`;
        }
        // do not update pageTitle if its event, when pageTitle changes that will trigger adobe SPA
        if (event && ((_b = (_a = window.c2foData) === null || _a === void 0 ? void 0 : _a.digitalData) === null || _b === void 0 ? void 0 : _b.pageTitle)) {
            pageTitle = window.c2foData.digitalData.pageTitle;
        }
        this.log.debug('Data layer Page Title : ', pageTitle);
        const payload = {
            site,
            section,
            subSection,
            pageTitle,
            domain: this.getUserEmailDomain(),
            userType: this.getUserEmailDomain().toLowerCase() === 'c2fo.com' ? 'internal' : 'client',
            trackEvents: {},
        };
        // capture last 10 events and update the datalayer so adobe launch code can read it back
        payload.trackEvents = this.getAdobeAnalyticsTrackEvents(event, attributes);
        if (window.c2foData) {
            window.c2foData.digitalData = Object.assign({}, payload);
        }
    }
    identify(traits, options) {
        const authServiceUuid = this.getAuthServiceUuidFromStorage();
        const sessionUuid = this.getSessionUuid();
        const segmentTraits = Object.assign(Object.assign({}, traits), { authServiceUuid });
        // if we don't have a user uuid we shouldn't call identify
        if (!authServiceUuid)
            return;
        if (this.segmentEnabled) {
            window.analytics.identify(authServiceUuid, segmentTraits, options);
        }
        this.log.debug('identify', { authServiceUuid, segmentTraits });
        const data = {
            authServiceUuid,
            data: segmentTraits,
            clientMeta: this.clientMeta(authServiceUuid, sessionUuid),
            userId: authServiceUuid,
        };
        this.httpService.post(`${this.c2foNodeApiUrl}/reporting/identify`, { data });
    }
    track(event, attributes) {
        const namespacedEvent = `${this.namespace}::${event}`;
        const authServiceUuid = this.getAuthServiceUuidFromStorage();
        const sessionUuid = this.getSessionUuid();
        const impersonationSubjectUuid = this.getImpersonationSubjectUuid();
        const clientMeta = this.clientMeta(authServiceUuid, sessionUuid);
        if (this.adobeEnabled) {
            this.setAdobeAnalyticsData(null, event, attributes);
        }
        // append authServiceUuid to attributes
        const data = Object.assign(Object.assign({}, attributes), { authServiceUuid });
        if (impersonationSubjectUuid) {
            data.impersonationSubjectUuid = impersonationSubjectUuid;
        }
        // append clientMeta to segment payload
        const segmentPayload = Object.assign(Object.assign({}, data), { clientMeta });
        // c2fo tracking payload
        const c2foPayload = {
            event: namespacedEvent,
            data,
            clientMeta,
        };
        this.log.debug('track', c2foPayload);
        if (this.segmentEnabled) {
            window.analytics.track(namespacedEvent, segmentPayload);
        }
        this.httpService.post(`${this.c2foNodeApiUrl}/reporting/track`, { data: c2foPayload });
    }
    sendPageEvent() {
        const authServiceUuid = this.getAuthServiceUuidFromStorage();
        const payload = {
            path: window.location.pathname,
            authServiceUuid,
        };
        this.log.debug('page', payload);
        if (this.segmentEnabled) {
            window.analytics.page(payload);
        }
    }
    page() {
        if (this.adobeEnabled) {
            this.setAdobeAnalyticsData(null, null);
        }
        this.sendPageEvent();
    }
    hash(title) {
        if (this.adobeEnabled) {
            this.setAdobeAnalyticsData(title.replace(/^#/, ''), null);
        }
        this.sendPageEvent();
    }
    clientMeta(authServiceUuid, sessionUuid) {
        return {
            createdDateTime: new Date(),
            uriStateName: window.location.pathname,
            uri: window.location.href,
            uriQueryParams: window.location.search,
            utmSource: window.sessionStorage ? window.sessionStorage.getItem(SESSION_STORAGE_KEYS.UTM_SOURCE) : '',
            utmMedium: window.sessionStorage ? window.sessionStorage.getItem(SESSION_STORAGE_KEYS.UTM_MEDIUM) : '',
            utmCampaign: window.sessionStorage ? window.sessionStorage.getItem(SESSION_STORAGE_KEYS.UTM_CAMPAIGN) : '',
            utmContent: window.sessionStorage ? window.sessionStorage.getItem(SESSION_STORAGE_KEYS.UTM_CONTENT) : '',
            utmTerm: window.sessionStorage ? window.sessionStorage.getItem(SESSION_STORAGE_KEYS.UTM_TERM) : '',
            authServiceUuid,
            sessionUuid,
        };
    }
}
exports.ReportingService = ReportingService;
//# sourceMappingURL=ReportingService.js.map